<template>
  <v-row class="align-center d-flex h-100">
    <v-col lg="4" md="7" class="mx-auto">
      <v-card class="card-shadow border-radius-xl py-1">
        <div
          class="
            card-padding
            text-center
            mt-n7
            bg-gradient-success
            shadow-success
            border-radius-lg
            mx-4
          "
        >
          <h4 class="text-h4 text-white font-weight-bold">Login</h4>
        </div>
       
        <div class="card-padding">
  
          <p>{{ $route.query.message == 'notAuthorized' ? 'Nicht authorisiert!' : '' }}</p>
          <v-form @submit.prevent="submitForm" ref="loginForm">
            <v-text-field
              label="Email"
              placeholder="Email"
              color="#e91e63"
              required
              v-model="form.email"
              class="font-size-input input-style"
              :rules="rules"
              @keyup.enter="submitForm"
            ></v-text-field>

            <v-text-field
              ref="passwordField"
              label="Password"
              placeholder="Password"
              color="#e91e63"
              required
              v-model="form.password"
              :type="showPassword ? 'text' : 'password'"
              class="font-size-input input-style"
              :rules="rules"
              @keyup.enter="submitForm"
            >
              <template v-slot:append>
                <v-btn
                  icon
                  small
                  @mousedown.prevent="togglePasswordVisibility"
                  tabindex="-1"
                  type="button"
                >
                  <i class="material-icons-round" style="font-size: 20px;">
                    {{ showPassword ? 'visibility' : 'visibility_off' }}
                  </i>
                </v-btn>
              </template>
            </v-text-field>

            <v-btn
              elevation="0"
              :ripple="false"
              height="43"
              :disabled="updating"
              class="
                font-weight-bold
                text-uppercase
                btn-default
                bg-gradient-default
                py-2
                px-6
                me-2
                mt-6
                mb-2
                w-100
              "
              color="#5e72e4"
              small
              type="submit"
              @click="submitForm"
              >
              <span v-if="!updating">Login</span>
              <v-progress-circular
                v-else
                indeterminate
                color="white"
                size="20"
                width="2"
              ></v-progress-circular>
            </v-btn>
          </v-form>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "sign-up-basic",
  data() {
    return {
      form: {

      },
      showPassword: false,
      rules: [
        value => !!value || 'Erforderlich.',
        value => (value && value.length >= 3) || 'Min 3 characters',
      ],
    };
  },
  computed: {
    authError(){
      return this.$store.getters.authError
    },
    authMessage(){
      return this.$store.getters.authMessage
    },
    darkMode(){
      return this.$store.getters.darkMode
    },
    contactFormSent(){
      return this.$store.getters.contactFormSent
    },
    updating(){
      return this.$store.getters.updating
    }
  },
  mounted(){
   
  },
  methods: {
    submitForm(){
      var payload = {
        email: this.form.email,
        password: this.form.password
      }
      this.$store.dispatch('login', payload)
    },
    togglePasswordVisibility(event) {
      if (event) {
        event.preventDefault()
        event.stopPropagation()
      }
      
      // Get the input element
      const field = this.$refs.passwordField
      if (!field) {
        this.showPassword = !this.showPassword
        return
      }
      
      // Find the actual input element
      const input = field.$el ? field.$el.querySelector('input') : null
      if (!input) {
        this.showPassword = !this.showPassword
        return
      }
      
      // Save cursor position and input value length
      const cursorPosition = input.selectionStart || input.value.length
      const valueLength = input.value.length
      
      // Toggle visibility
      this.showPassword = !this.showPassword
      
      // Restore cursor position after DOM update
      this.$nextTick(() => {
        const newInput = field.$el ? field.$el.querySelector('input') : null
        if (newInput) {
          // Focus and set cursor position
          newInput.focus()
          // Ensure cursor position is within bounds
          const safePosition = Math.min(cursorPosition, valueLength)
          newInput.setSelectionRange(safePosition, safePosition)
        }
      })
    }
  },
};
</script>
